<template>

  <div>
    <div class="gallery-alert__container">
      <div class="container">
        <div class="row">
          <div class="col-xs-10 col-sm-8 col-md-6 col-lg-4">
            <h3 class="gallery-alert__heading">Already Ordered?</h3>
            <div class="gallery-header__description">
              <p>
                <a
                  href="#"
                  class="button enlarge__cta-button"
                  @click="openModal"
                >
                  Click Here to Access Your Order
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <search-email-modal
        :show-modal="modalVisible"
        @close-modal="closeModal"
      />
    </div>
</div></template>

<script>
import SearchEmailModal from './SearchEmailModal'

export default {
  name: 'PreOrderSearchEmail',
  components: {
    SearchEmailModal
  },
  data () {
    return {
      modalVisible: false
    }
  },
  methods: {
    openModal () {
      this.modalVisible = true
    },
    closeModal () {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery-alert__container {
  margin-top: 0.5em;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/proofs/index/components/PreOrderSearchEmail/PreOrderSearchEmail.vue